import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';
import { WithdrawalsHistoryViewModule } from '@modules/withdrawals-history/submodules/view/WithdrawalsHistoryViewModule';

import {
  ADMIN_WITHDRAWALS_HISTORY_LIST_ROUTE_NAME,
  ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME,
  TRANSLATION_GROUP_WITHDRAWALS_HISTORY,
  WITHDRAWALS_HISTORY_PERMISSIONS,
} from './constants';
import { getTranslationKeys } from './translations';

export class WithdrawalsHistoryModule extends AppModule {
  protected submodules = [
    new WithdrawalsHistoryViewModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME,
      path: 'withdrawals-history',
      permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'WithdrawalsHistoryListPage',
    });

    router.addChildRoute(ADMIN_WITHDRAWALS_HISTORY_ROUTE_NAME, {
      name: ADMIN_WITHDRAWALS_HISTORY_LIST_ROUTE_NAME,
      path: '',
      permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
      component: () => import('./pages/WithdrawalsHistoryListPage/WithdrawalsHistoryListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_ADMIN_WITHDRAWALS_HISTORY'),
      to: {
        name: ADMIN_WITHDRAWALS_HISTORY_LIST_ROUTE_NAME,
      },
      permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
      id: ADMIN_WITHDRAWALS_HISTORY_LIST_ROUTE_NAME,
      order: 110,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_WITHDRAWALS_HISTORY, getTranslationKeys);
  }
}
